import { render } from "./AgencyEmailConnections.vue?vue&type=template&id=2b6bb282&scoped=true"
import script from "./AgencyEmailConnections.vue?vue&type=script&lang=js"
export * from "./AgencyEmailConnections.vue?vue&type=script&lang=js"

import "./AgencyEmailConnections.vue?vue&type=style&index=0&id=2b6bb282&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6bb282"]])

export default __exports__